import { Tabs } from "antd"
import { UnitProps } from "../unitTypes"
import { LimitMain } from "./LimitMain/LimitMain"
import { LimitPhaseDataTab } from "./LimitPhaseDataTab/LimitPhaseDataTab"
import { useRequest } from "ahooks"
import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { getSimUnitData } from "@/services/project/simulation.service"
import { useContext, useEffect } from "react"
import { UnitImageWithStatus } from "../common/UnitImageWithStatus"

const StreamSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="361" height="74" viewBox="0 0 361 74" fill="none">
<path d="M0.666667 37C0.666667 39.9455 3.05448 42.3333 6 42.3333C8.94552 42.3333 11.3333 39.9455 11.3333 37C11.3333 34.0545 8.94552 31.6667 6 31.6667C3.05448 31.6667 0.666667 34.0545 0.666667 37ZM6 38L116 38V36L6 36V38Z" fill="#319800"/>
<g clip-path="url(#clip0_882_59461)">
<path class="unit-path" d="M207.261 64L243 37L207.261 10V20.9575L118 20.9575V52.4371L207.261 52.4371V64Z" stroke="black" stroke-width="4"/>
</g>
<path d="M349.667 37C349.667 39.9455 352.054 42.3333 355 42.3333C357.946 42.3333 360.333 39.9455 360.333 37C360.333 34.0545 357.946 31.6667 355 31.6667C352.054 31.6667 349.667 34.0545 349.667 37ZM245 38H355V36H245V38Z" fill="#319800"/>
<defs>
<clipPath id="clip0_882_59461">
<rect width="129" height="74" fill="white" transform="translate(116)"/>
</clipPath>
</defs>
</svg>
`


export const BatteryLimit = (props: UnitProps) => {
  const {unit, data} = props

  const items = [
    {
      key: '1',
      label: 'Main',
      children: <LimitMain data={data} unit={unit} />,
    },
    {
      key: '2',
      label: 'Phase Data',
      children: <LimitPhaseDataTab data={data} unit={unit}/>,
    },
  ]
  
  return <div>
    <UnitImageWithStatus svg={StreamSvg} data={data} height={60}/>
    <Tabs defaultActiveKey="1" items={items} style={{width: '100%'}} />
  </div>
}